module.exports = __webpack_public_path__ + "static/media/TAW.4665382c.svg";